<template>
  <div>
    <div class="row">
      <div class="col-sm-4">
        <table class="stats">
          <tbody>
            <tr>
              <td>
                <p><span id="total-conversations">Total Conversations</span></p>
                <b-tooltip target="total-conversations" placement="bottom">
                  Number of active or touched (received, replied to, status changed, assigned) conversations.
                </b-tooltip>
                <div class="data">{{mailboxStats.total_messages}}</div>
              </td>
              <td>
                <p><span id="new-conversations">New Conversations</span></p>
                <b-tooltip target="new-conversations" placement="bottom">
                  Number of new conversations created by customers or users.
                </b-tooltip>
                <div class="data">{{mailboxStats.new_messages}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="emails-received">Emails Received</span></p>
                <b-tooltip target="emails-received" placement="bottom">
                  Number of emails received from customers. Each incoming thread in a conversation counts towards this total.
                </b-tooltip>
                <div class="data">{{mailboxStats.total_threads}}</div>
              </td>
              <td>
                <p><span id="customers">Customers</span></p>
                <b-tooltip target="customers" placement="bottom">
                  Number of customers with conversations created or updated.
                </b-tooltip>
                <div class="data">{{mailboxStats.total_customers}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="conversations-per-day">Conversations per Day</span></p>
                <b-tooltip target="conversations-per-day" placement="bottom">
                  Average number of new or updated conversations each day.
                </b-tooltip>
                <div class="data">{{mailboxStats.messages_per_day}}</div>
              </td>
              <td>
                <p><span id="busiest-day">Busiest Day</span></p>
                <b-tooltip target="busiest-day" placement="bottom">
                  Day of the week with the highest number of new emails on average.
                </b-tooltip>
                <div class="data">{{mailboxStats.busiest_day}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="customers-helped">Customers Helped</span></p>
                <b-tooltip target="customers-helped" placement="bottom">
                  Number of unique customers your team has replied to.
                </b-tooltip>
                <div class="data">{{customersHelped}}</div>
              </td>
              <td>
                <p><span id="replies-per-day">Replies per Day</span></p>
                <b-tooltip target="replies-per-day" placement="bottom">
                  Average number of outgoing emails per day.
                </b-tooltip>
                <div class="data">{{repliesPerDay}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <p><span id="closed">Closed</span></p>
                <b-tooltip target="closed" placement="bottom">
                  The number of conversations closed in the time period.
                </b-tooltip>
                <div class="data">{{closedMessages}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-8">
        <MailboxOverviewChart />
      </div>
    </div>

    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Tags" active>
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="tags" :fields="tagsFields" :per-page="10"/>
            </div>
          </div>
        </b-tab>
        <b-tab title="Most Active Customers">
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="customers" :fields="customersFields" :per-page="10"  />
            </div>
          </div>
        </b-tab>
        <b-tab title="User Stats">
          <div class="row">
            <div class="col-sm-12">
              <b-table :items="usersStats" :fields="usersFields"/>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import MailboxOverviewChart from './MailboxOverviewChart'
export default {
  name: 'AllChannelsReport',
  components: {
    MailboxOverviewChart
  },
  data () {
    return {
      usersFields: {
        '0': {
          label: 'User',
          sortable: true
        },
        '1': {
          label: 'Replies',
          sortable: true
        },
        '2': {
          label: 'Closed',
          sortable: true
        },
        '3': {
          label: 'Customers Helped',
          sortable: true
        }
      },
      usersStats: [],
      customersHelped: 0,
      repliesPerDay: 0,
      closedMessages: 0,
      mailboxStats: {},
      tags: [],
      customers: [],
      chartData: {},
      customersFields: {
        '0': {
          label: 'Most Active Customers',
          sortable: true
        },
        '1': {
          label: '#',
          sortable: true
        }
      },
      tagsFields: {
        '0': {
          label: 'Tag',
          sortable: true
        },
        '1': {
          label: '#',
          sortable: true
        },
        '2': {
          label: '%',
          sortable: true
        }
      }
    }
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates'])
  },
  methods: {
    getTeamReport () {
      this.$http.get('/team_stats', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then((response) => {
          this.usersStats = response.data.users
          this.customersHelped = response.data.customers_helped
          this.closedMessages = response.data.closed_messages
          this.repliesPerDay = response.data.replies_per_day
          this.chartData.categories = response.data.chart_data.categories
          this.chartData.data = response.data.chart_data.data
          this.$root.$emit('reportLoadingComplete')
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('errorLoadingReport')
        })
    },
    getTagStats () {
      var vm = this
      this.$http.get('/tag_stats', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.tags = response.data
        })
        .catch(e => { console.log(e) })
    },
    getMostActiveCustomers () {
      var vm = this
      this.$http.get('/most_active_customers', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.customers = response.data
        })
        .catch(e => { console.log(e) })
    },
    getMailboxStats () {
      var vm = this
      this.$http.get('/messages_stats', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.mailboxStats = response.data
        })
        .catch(e => { console.log(e) })
    },
    getData () {
      if (this.currentReportMailbox.id) {
        this.$root.$emit('loadingReport')
        this.getMailboxStats()
        this.getTagStats()
        this.getMostActiveCustomers()
        this.getTeamReport()
      }
    }
  },
  watch: {
    currentReportMailbox () {
      this.getData()
    },
    reportDates () {
      this.getData()
    }
  }
}
</script>
<style scoped>
>>> .v-select {
      background: white;
      margin: 2px;
    }
@media (min-width: 992px) {
  .stats {
    width: 415px;
    background: 0 0;
    border-collapse: separate;
    border-spacing: 20px 0;
    table-layout: fixed;
    margin-top: 10px;
  }
}
  .stats {
    background: 0 0;
    border-collapse: separate;
    border-spacing: 20px 0;
    table-layout: fixed;
    width: 100%;
  }
  .stats p {
    color: #1b3046;
    cursor: help;
    font-size: 14px;
    margin-bottom: 2px;
  }

  .stats .data {
    color: #436d8c;
    font-size: 35px;
    margin-right: 12px;
  }
  .stat-tables {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/reports/AllChannelsReport.vue